import { useEffect } from 'react';
import Nav        from './components/Nav';
import Hero       from './components/Hero';
import Marquee    from './components/Marquee';
import Skills     from './components/Skills';
import Projects   from './components/Projects';
import Experience from './components/Experience';
import Contact    from './components/Contact';
import Footer     from './components/Footer';

export default function App() {
  useEffect(() => {
    document.title = 'Yosry Mlika — Full-Stack Developer & Founder | Dubai, UAE';
  }, []);

  return (
    <>
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Skills />
        <Projects />
        <Experience />
        <Contact />
      </main>
      <Footer />
    </>
  );
}
